import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCube } from '@fortawesome/free-solid-svg-icons';
import SidebarPageLayout from '../../components/layout/SidebarPageLayout';
import Breadcrumbs from '../../components/layout/Breadcrumbs';
import { apiFetch } from '../../api/apiClient';

function Application() {
  const [appContext, setAppContext] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isContextVisible, setIsContextVisible] = useState(false);

  useEffect(() => {
    document.title = 'Vivosol Plant Performance Insights Hub | Admin / Application';
    let cancelled = false;
    apiFetch('/api/app-context')
      .then((body) => {
        if (!cancelled) setAppContext(body?.appContext ?? null);
      })
      .catch((err) => {
        if (!cancelled) setError(err);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const contextJson = appContext ? JSON.stringify(appContext, null, 2) : '';

  return (
    <SidebarPageLayout id="adminApplication">
      <div className="content p-5">
        <h1 className="mb-0">Application</h1>
        <Breadcrumbs />
        <div className="panel p-3">
          <div className="header d-flex justify-content-between pb-3">
            <div className="left d-flex gap-3">
              <span><FontAwesomeIcon icon={faCube} /> APPLICATION</span>
            </div>
          </div>
          <div className="body pt-3">
            <button
              type="button"
              className="app-context-toggle"
              onClick={() => setIsContextVisible((prev) => !prev)}
            >
              {isContextVisible ? 'Hide App Context' : 'View App Context'}
            </button>
            {isContextVisible ? (
              <pre className="app-context-json">
                {isLoading
                  ? 'Loading application context…'
                  : error
                    ? `Unable to load application context. ${error.message || ''}`
                    : contextJson || 'No application context is stored for this login.'}
              </pre>
            ) : null}
          </div>
        </div>
      </div>
    </SidebarPageLayout>
  );
}

export default Application;
